<template>
    <nav aria-label="Page navigation example">
        <ul class="pagination">
            <li class="page-item">
                <a class="page-link" @click="navigate($event, source.current_page - 1)" href="#" :class="{disabled: source == '' || source.current_page == 1}">
                    <span aria-hidden="true">Anterior</span>
                </a>
            </li>

            <template v-for="(page, index) in pages">
                <li class="page-item" :key="index" :class="{active: source.current_page == page}">
                    <span class="page-link" v-if="page == '...'">{{page}}</span>
                    <a class="page-link" v-if="page != '...'" @click="navigate($event, page)" href="" :class="{disabled: page == source.current_page}">{{ page }}</a>
                </li>
            </template>

            <li class="page-item">
                <a class="page-link" @click="navigate($event, source.current_page + 1)" href="#" :class="{disabled: source.current_page == source.last_page}">
                    <span aria-hidden="true">Próximo</span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>

export default {
  props: ['source'],

  data () {
    return {
      pages: [],
    }
  },
  methods: {
    navigate (event, page) {
      event.preventDefault()
      this.$emit('navigate', page)
    },
    generatePagesArray: function (currentPage, collectionLength, rowsPerPage, paginationRange) {
      var pages = []
      var totalPages = Math.ceil(collectionLength / rowsPerPage)
      var halfWay = Math.ceil(paginationRange / 2)
      var position

      if (currentPage <= halfWay) {
        position = 'start'
      } else if (totalPages - halfWay < currentPage) {
        position = 'end'
      } else {
        position = 'middle'
      }

      var ellipsesNeeded = paginationRange < totalPages
      var i = 1
      while (i <= totalPages && i <= paginationRange) {
        var pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages)
        var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'))
        var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'))
        if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
          pages.push('...')
        } else {
          pages.push(pageNumber)
        }
        i++
      }
      return pages
    },

    calculatePageNumber: function (i, currentPage, paginationRange, totalPages) {
      var halfWay = Math.ceil(paginationRange / 2)
      if (i === paginationRange) {
        return totalPages
      } else if (i === 1) {
        return i
      } else if (paginationRange < totalPages) {
        if (totalPages - halfWay < currentPage) {
          return totalPages - paginationRange + i
        } else if (halfWay < currentPage) {
          return currentPage - halfWay + i
        } else {
          return i
        }
      } else {
        return i
      }
    }

  },

  watch: {
    source () {
      let s = this.source
      this.pages = this.generatePagesArray(s.current_page, s.total, s.per_page, 12)
    }
  }
}

</script>
<style scoped>
    .disabled{
        color: #808080;
        pointer-events: none;
        cursor: not-allowed !important;
    }
</style>
